module.exports = __webpack_public_path__ + "img/project-edu-03.e2589f26.png";